export default "__VITE_ASSET__CVrGGp1j__"